<template>
  <div>
    <section class="grid-flex">
      <div class="box">
        <div class="box-title flex between middle">
          <h2 class="">
            Configuração
          </h2>
        </div>
        <div class="box-content">
          <div class="flex row middle">
            <!-- form account info -->
            <div class="flex-1 account middle center">
              <h4>Dados de cadastro</h4>
              <div class="flex column margin-top-m item">
                <div class="flex-1 w100">
                  <label>ID</label>
                  <input
                    class="input"
                    type="text"
                    v-model="account.id"
                    disabled=""
                    readonly=""
                  />
                </div>

                <!-- <div class="flex-1 w100 margin-top-m">
                  <label>Nome:</label>
                  <input class="input" type="text" v-model="account.name" disabled/>
                </div> -->

                <div class="flex-1 w100 margin-top-m">
                  <label>Nome:</label>
                  <input class="input" type="text" v-model="account.corporate_name" disabled/>
                </div>

                <div class="flex-1 w100 margin-top-m">
                  <label>Tipo de Conta:</label>
                  <input class="input" type="text" v-model="account.document_type" disabled/>
                </div>

                <div class="flex-1 w100 margin-top-m">
                  <label>Documento:</label>
                  <input class="input" type="text" v-model="account.document"  disabled/>
                </div>
              </div>
            </div>
            <!-- subscription info -->
            <div class="flex-1 subscription">
              <h4>Dados Bancarios:</h4>
              <div>
                <validation-observer ref="form" v-slot="{ handleSubmit }">
                  <form @submit.prevent="handleSubmit(register)">
                    <div class="item margin-top-l">
                      <p>A chave PIX deve ser do titular da conta. Ou seja, mesmo <b>NOME</b> e <b>CPF</b>/<b>CNPJ</b>.</p>
                      <div class="margin-top-s">
                        <small>
                          <b>Atenção:</b> Caso a chave não seja do titular, os saques serão <b>rejeitados</b>.
                        </small>
                      </div>
                    </div>
                    <div class="margin-top-l">
                      <validation-provider
                        name="nome"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div
                          class="form-field item group-input "
                          :class="{ errors: errors[0] }"
                        >
                          Banco
                          <input type="text" v-model="account.bank_name" placeholder="Nome do Banco" />
                          <span class="erros-alert">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                      <div class="form-field item group-input ">
                        Tipo de chave
                        <div class="margin-top-s">
                          <select
                            class="input"
                            v-model="account.type_pix"
                          >
                            <option value=""> - </option>
                            <option
                              v-for="(v, k) in typePixs"
                              :key="k"
                              :value="v.value"
                            >
                              {{ v.label }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="margin-top-m">
                        <validation-provider
                          name="nome"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <div
                            class="form-field item group-input "
                            :class="{ errors: errors[0] }"
                          >
                            Chave Pix
                            <input type="text" v-model="account.pix" placeholder="Chave Pix" />
                            <span class="erros-alert">{{ errors[0] }}</span>
                          </div>
                        </validation-provider>
                      </div>
                    </div>
                  </form>
                </validation-observer>
              </div>
            </div>
            
          </div>
          <div class="flex center margin-top-l">
              <div class="button primary" @click="updateAccount()">
                Atualizar Dados Bancarios
              </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { updateAccount } from "@/services/account";


export default {
  name: "config-account",
  components: {},
  data() {
    return {
      loading: false,
      typePixs: [
        {
          value: 'PHONE',
          label: 'TELEFONE'
        },
        {
          value: 'CPF',
          label: 'CPF'
        },
        {
          value: 'CNPJ',
          label: 'CNPJ'
        },
        {
          value: 'EMAIL',
          label: 'EMAIL'
        },
        {
          value: 'RANDOM',
          label: 'ALEATÓRIA'
        },
      ]
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    isStripe() {
      return this.account && this.account.payment_platform === 'STRIPE'
    },
    isFreemium() {
      return this.account && this.account.plan === 'freemium'
    },
    isAccountLimitExceeded() {
      return this.account && this.account.status === 'LIMIT_EXCEEDED'
    },
  },
  methods: {
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
    updateAccount() {

      console.log('this.account', this.account)
      let params = {
        name: this.account.name,
        bank_name: this.account.bank_name,
        type_pix: this.account.type_pix,
        pix: this.account.pix,
      };
      updateAccount(params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Conta atualizada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao atualizar conta",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.account {
  padding: 16px;
  border-right: 1px solid #c2c2c235;
  height: 430px;
}

.subscription {
  padding: 16px;
  ul {
    padding-left: 15px;
    li {
      // list-style-type: none;
      padding-top: 8px;
      padding-bottom: 8px;
      margin-bottom: 8px;
    }
  }
}
</style>
